import { render, staticRenderFns } from "./DistintaBase.vue?vue&type=template&id=3fea5e0b&"
import script from "./DistintaBase.vue?vue&type=script&lang=js&"
export * from "./DistintaBase.vue?vue&type=script&lang=js&"
import style0 from "./DistintaBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports